module.exports = __webpack_public_path__ + "img/columns.f061f031.svg";